import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { URL_TEMPLATES } from '../service/endpoints';
import { getData } from '../service/APIClient';

// Fetch users
export const fetchTemplates = createAsyncThunk('templates/fetchTemplates', async () => {
  let templates = [];
  let currentPage = 1;
  let totalPages = 1;

  try {
    while (currentPage <= totalPages) {
      const response = await getData(URL_TEMPLATES + `?page=${currentPage}`);
      templates = [...templates, ...response.items];
      totalPages = response.totalPages;
      currentPage++;
    }
    return templates.map(template => ({
      id: template.id,
      name: template.name,
      locations: template.locations,
      sourceCode: template.sourcecode,
    }));
  } catch (error) {
    throw new Error('Failed to fetch templates');
  }
});

// Slice
const templatesSlice = createSlice({
  name: 'templates',
  initialState: {
    data: [],
    status: 'idle',
    addStatus: 'idle',
    deleteStatus: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch Templates
      .addCase(fetchTemplates.pending, state => {
        state.loading = true;
        state.status = 'loading'
        state.error = null;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.error.message;
      })
  }
});

// Export actions
export default templatesSlice.reducer;
